import insertLoginData from '../data_management/insertLoginData';
import {LoginInteractor as CoreLoginInteractor} from '@mojility/coach-core';

class LoginInteractor extends CoreLoginInteractor {

  constructor(dataService, accountGateway, initialDataInteractor) {
    super(dataService, accountGateway);
    this.initialDataInteractor = initialDataInteractor;
  }

  login(username, password, eula = null) {
    return this.authenticate(username, password, eula)
      .then(loginData => {
        insertLoginData(this.initialDataInteractor, loginData);
        this.initialDataInteractor.saveToStorage();
      });
  }

  invalidate() {
    super.invalidate();
    this.initialDataInteractor.invalidateSession();
  }
}

export default LoginInteractor
